/**
 * スタイル定義
 */
export const styles = (theme) => ({
  //アコーディオンのボタン
  accordionButton: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.etcButton.main,
    height: theme.spacing(3),
    minWidth: theme.spacing(9),
    padding: '0px',
    marginLeft: theme.spacing(1),
  },
  newIcon: {
    backgroundColor: theme.palette.newInfo.main,
    color: theme.palette.newInfo.contrastText,
    paddingLeft: 4,
    paddingRight: 4,
    marginRight: 4,
  },
  textEllipsis: {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },

  //------------ UserInfoField ------------
  //ユーザ情報アコーディオン
  userInfoAccordion: {
    backgroundColor: theme.palette.table.header.primary.main,
    color: theme.palette.table.header.primary.contrastText,
    borderColor: theme.palette.table.header.primary.main,
    '& #title': {
      color: theme.palette.table.header.primary.contrastText,
      fontSize: theme.typography.fontSize * 1.25,
      height: '1.25em',
    },
  },
  //ユーザ情報
  userInfo: {
    height: 340,
  },
  //ユーザ役割
  userInfoAuthority: {
    color: theme.palette.table.header.primary.contrastText,
    height: '1.25em',
  },
  //ユーザー情報のボタン
  userInfoButton: {
    width: '100%',
    background: 'white',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1),
    '&&:hover': {
    backgroundColor: '#ccc',
  },
  },
  //ユーザー情報のボタンのテキスト
  userInfoButtonText: {
    width: '100%',
    paddingLeft: theme.spacing(1),
    textAlign: 'left',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxHeight: '2.5em',
    overflow: 'hidden',
  },
  //ユーザー情報(メールアドレス)のボタンのテキスト
  userMailInfoButtonText: {
    width: '100%',
    paddingLeft: theme.spacing(1),
    textAlign: 'left',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxHeight: '5.5em',
    overflow: 'hidden',
  },

  //ユーザー情報未設定
  noUserInfo: {
    color: 'red',
  },
  noUserInfoButton: {
    background: 'pink',
  },
  //------------ GrouphisaiInfoField ------------
  grouphisaiToggleButton: {
    '& > div': {
      maxWidth: 150,
    },
  },
  //------------ NoticeInfoField ------------
  //メンテナンス情報エリア
  noticeInfoArea: {
    height: 200,
    overflowY: 'scroll',
  },

  //メンテナンス情報登録日時
  noticeInfoRegisterDt: {
    height: '1.25em',
  },
  //------------ SafetyInfoField ------------
  safetyButton: {
    width: '90%',
    height: '100%',
    backgroundColor: '#199EEA',
    '&:hover': {
      backgroundColor: '#199EEA',
    },
  },
  safetyButtonText: {
    color: '#FFFFFF',
  },
  safetyButtonNoUserInfoText: {
    color: 'red',
  },
  safetyInfoOverview: {
    marginLeft: '1rem',
    textIndent: '-1rem',
  },
  downloadArea: {
    padding: theme.spacing(1),
    borderColor: 'black',
    borderWidth: 1,
    borderStyle: 'solid',
  },
  downloadBadge: {
    margin: theme.spacing(1),
    height: 40,
  },
});
